import { Button, FormControl, Grid, TextField, Typography, makeStyles, CircularProgress, FormHelperText, AppBar } from '@material-ui/core';

import React from 'react';
import { HomeContext } from '../../Home/HomeContext';
import { AuthContext } from '../../Authentication/AuthContext';
import { PageLocation } from '../../../shared/enum/PageLocation';
import InfluencerSpreadsheetService from '../../../Services/InfluencerService';
import { AxiosError, AxiosResponse } from 'axios';
import InfluencerService from '../../../Services/InfluencerService';
import { InfluencerModel } from '../../../Models/InfluencerModel';
import { InfluencersAuxiliarResponse } from '../../../Models/InfluencerAuxiliarModel';
import { StatusUpload } from '../../../shared/enum/StatusUpload';
import { InfluencerUploadResultInitial, InfluencerUploadResultModel } from '../../../Models/InfluencerUploadResultModel';
import { format } from 'date-fns';
import { theme } from '../../../theme';
import { Autocomplete } from '@material-ui/lab';
import { BasicConfirmDialog } from '../../../shared/components/BasicConfirmDialog';

// Função utilitária para validar URL
function isValidUrl(url: string): boolean {
    try {
        new URL(url);
        return true;
    } catch {
        return false;
    }
}
export interface IHistoryClassificationProps {
    handlePageLocation: (location: PageLocation) => void;
}

const useStyles = makeStyles((theme) => ({
    toolbar: {
        padding: '8px',
        backgroundColor: '#F0F1F1',
    },
    baritems: {
        width: '100%',
        paddingLeft: theme.spacing(3),
        maxWidth: '1152px',
    },
    itens: {
        width: '100%',
        color: 'primary',
    },
    loading: {
        minHeight: '80vh'
    },
    titleContainer: {
        marginBottom: theme.spacing(3)
    },
    root: {
        padding: theme.spacing(3),
        width: '100%',
        maxWidth: '1152px',
    },
    title: {
        margin: '20px 0px 32px'
    },
    tabs: {
        justifyContent: 'space-between',
        display: 'flex'
    },
    addNewButtonGrid: {
        justifyItems: 'center'
    },
    emptyTable: {
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        maxWidth: '1800px',
        padding: theme.spacing(0, 4)
    },
}));

function toBrasiliaISOString(date: Date) {
    const offsetMs = 3 * 60 * 60 * 1000;
    const brasiliaDate = new Date(date.getTime() - offsetMs);
    return brasiliaDate.toISOString().slice(0, 19); // 'YYYY-MM-DDTHH:mm:ss'
}

type ErrosFormulario = Partial<Record<keyof InfluencerModel, string>>;

export default function InfluencerSingleProfileSubmit() {
    const classes = useStyles();
    const authContext = React.useContext(AuthContext);
    const homeContext = React.useContext(HomeContext);
    const [influencers, setInfluencers] = React.useState<InfluencerModel[]>([{} as InfluencerModel]);
    const clientEnable = homeContext.influencerClientEnable;
    const [status, setStatus] = React.useState<StatusUpload>(StatusUpload.INPUT);
    const [resultUpload, setResultUpload] = React.useState<InfluencerUploadResultModel>(InfluencerUploadResultInitial);
    const [filters, setFilters] = React.useState<InfluencersAuxiliarResponse>();
    const [loading, setLoading] = React.useState(false);
    const dataAtual = toBrasiliaISOString(new Date());

    const [erros, setErros] = React.useState<ErrosFormulario[]>([{} as ErrosFormulario]);
    const [showConfirmExit, setShowConfirmExit] = React.useState<boolean>(false);

    React.useEffect(() => {
        setLoading(true);
        if (clientEnable) {
            InfluencerService.getInfluencersBrandByClient(clientEnable.id_cliente)
                .then((res: AxiosResponse) => {

                    setFiltersData(res.data);

                    const initialInfluencer = {
                        id_usuario: authContext.login.user.id,
                        dataRecebimento: dataAtual,
                        id_solicitante: authContext.login.user.username,
                        email: authContext.login.user.email || '',
                    } as InfluencerModel;

                    setInfluencers([initialInfluencer]);
                    setLoading(false);
                })
                .catch((error: AxiosError) => { setLoading(false); homeContext.showError('', error); });
        }

    }, []);

    const setFiltersData = (data: InfluencersAuxiliarResponse) => {
        setFilters(data);
    };

    // Função para adicionar novo formulário
    const addNewInfluencer = () => {
        const baseData = influencers[0]; // Usar dados do primeiro como base
        const newInfluencer = {
            ...baseData, // Copia todos os dados do primeiro
            nome: '', // Limpa campos individuais
            url_perfil: '',
            observacoes: ''
        };
        setInfluencers([...influencers, newInfluencer]);
        setErros([...erros, {} as ErrosFormulario]);
    };

    // Função para remover formulário
    const removeInfluencer = (index: number) => {
        if (influencers.length > 1) {
            const newInfluencers = influencers.filter((_, i) => i !== index);
            const newErros = erros.filter((_, i) => i !== index);
            setInfluencers(newInfluencers);
            setErros(newErros);
        }
    };

    const handleChange = (index: number, prop: keyof InfluencerModel) => (event: React.ChangeEvent<HTMLInputElement>) => {
        const newInfluencers = [...influencers];
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        newInfluencers[index][prop] = event.target.value;
        setInfluencers(newInfluencers);
    };

    const handleChangeDate = (prop: keyof InfluencerModel) =>
        (date: Date | null) => {
            if (date) {
                const newInfluencers = [...influencers];
                newInfluencers.forEach(influencer => {
                    (influencer as any)[prop] = toBrasiliaISOString(date);
                });
                setInfluencers(newInfluencers);
            }
        };

    const handleChangeSelect = (prop: keyof InfluencerModel) =>
        (event: React.ChangeEvent<{ value: unknown }>) => {
            const newInfluencers = [...influencers];
            newInfluencers.forEach(influencer => {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                //@ts-ignore
                influencer[prop] = event.target.value as string;
            });
            setInfluencers(newInfluencers);
        };

    async function uploadInfluencer(clearAfterSuccess = false) {

        const errosValidacao = validarCampos();
        const hasErrors = errosValidacao.some(erro => Object.keys(erro).length > 0);

        if (hasErrors) {
            setErros(errosValidacao);
            return;
        }

        setErros(Array(influencers.length).fill({} as ErrosFormulario));

        const clientId = clientEnable?.id_cliente;
        setResultUpload(InfluencerUploadResultInitial);
        setLoading(true);

        if (clientId) {
            try {
                // Preparar array com clientId adicionado a cada influenciador
                const influencersWithClientId = influencers.map(influencer => ({
                    ...influencer,
                    clientId
                }));


                // Enviar array completo para o backend
                await InfluencerSpreadsheetService.postSpreadsheetFileInfluencerDetachedICE(
                    authContext.login.user.id,
                    influencersWithClientId
                );

                homeContext.showSuccess(`${influencers.length} influenciador(es) enviado(s) com sucesso. O prazo para retorno da análise é de 5 dias úteis. Caso seu pedido tenha urgência, entre em contato com o time de comunicação no canal do Slack #fale-com-reputação-gb`);

                // Redirecionar para a tela de consulta
                homeContext.setPageLocation(PageLocation.INFLUENCER_PROFILE_CONSULT);
                if (clearAfterSuccess) {
                    clearInputs();
                }
            } catch (error) {
                homeContext.showError('Erro ao Salvar os Influenciadores.');
            } finally {
                setLoading(false);
            }
        }
    }

    const validarCampos = (): ErrosFormulario[] => {
        const novosErros: ErrosFormulario[] = [];

        influencers.forEach((influencer, index) => {
            const erroInfluencer: ErrosFormulario = {};

            const camposObrigatorios: (keyof InfluencerModel)[] = [
                'area',
                'marca',
                'vp',
                'nome',
                'url_perfil',
                'iniciativa',
                'objetivoContratacao',
                'id_solicitante',
                'finalidade',
                'formato',
                'canaisICE',
                'abrangencia',
            ];

            camposObrigatorios.forEach((campo) => {
                const valor = influencer[campo];
                if (typeof valor === 'string' && !valor.trim()) {
                    erroInfluencer[campo] = 'Campo obrigatório.';
                } else if (valor === null || valor === undefined) {
                    erroInfluencer[campo] = 'Campo obrigatório.';
                }
            });

            // Validação específica para URL
            if (influencer.url_perfil && typeof influencer.url_perfil === 'string' && influencer.url_perfil.trim()) {
                if (!isValidUrl(influencer.url_perfil)) {
                    erroInfluencer.url_perfil = 'Informe uma URL válida.';
                }
            }

            novosErros.push(erroInfluencer);
        });

        return novosErros;
    };

    const clearInputs = () => {
        const baseInfluencer = {
            ['id_usuario']: authContext.login.user.id,
            ['dataRecebimento']: dataAtual,
            ['id_solicitante']: influencers[0].id_solicitante,
            ['email']: authContext.login.user.email || '',
        } as InfluencerModel;

        setInfluencers([baseInfluencer]);
        setErros([{} as ErrosFormulario]);
    };

    const hasDataFilled = () => {
        // Verifica se há dados preenchidos nos campos principais
        const firstInfluencer = influencers[0];

        // Verifica campos que são diferentes dos valores iniciais/padrão
        const hasMainDataFilled = (
            (firstInfluencer?.area && firstInfluencer.area.trim() !== '') ||
            (firstInfluencer?.marca && firstInfluencer.marca.trim() !== '') ||
            (firstInfluencer?.vp && firstInfluencer.vp.trim() !== '') ||
            (firstInfluencer?.iniciativa && firstInfluencer.iniciativa.trim() !== '') ||
            (firstInfluencer?.objetivoContratacao && firstInfluencer.objetivoContratacao.trim() !== '') ||
            (firstInfluencer?.finalidade && firstInfluencer.finalidade.trim() !== '') ||
            (firstInfluencer?.formato && firstInfluencer.formato.trim() !== '') ||
            (firstInfluencer?.abrangencia && firstInfluencer.abrangencia.trim() !== '') ||
            (firstInfluencer?.canaisICE && Array.isArray(firstInfluencer.canaisICE) && firstInfluencer.canaisICE.length > 0)
        );

        // Verifica se há dados de influenciadores preenchidos
        const hasInfluencerDataFilled = influencers.some(influencer =>
            (influencer.nome && influencer.nome.trim() !== '') ||
            (influencer.url_perfil && influencer.url_perfil.trim() !== '') ||
            (influencer.observacoes && influencer.observacoes.trim() !== '')
        );

        return hasMainDataFilled || hasInfluencerDataFilled;
    };

    const saveInputs = () => {
        return (
            <Grid
                container
                justifyContent="flex-end"
                alignItems="center"
                spacing={3}
            >
                <Grid
                    item xs={4}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => uploadInfluencer(true)}
                        size="large"
                        fullWidth>
                        {'Enviar'}
                    </Button>
                </Grid>
            </Grid>
        );
    };

    const saveAddInputs = () => {
        return (

            <Grid
                item xs={3}>
                <Button
                    variant="outlined"
                    color="primary"
                    onClick={addNewInfluencer}
                    size="large"
                    fullWidth>
                    {'+ Adicionar Perfil'}
                </Button>
            </Grid>
        );
    };

    const saveRemoveInputs = (actualIndex: number) => {
        return (
            <Grid
                item xs={3}>
                <Button
                    variant="outlined"
                    size="large"
                    fullWidth
                    onClick={() => removeInfluencer(actualIndex)}
                    style={{
                        borderColor: '#B60C0C',
                        color: '#B60C0C',
                        backgroundColor: 'transparent'
                    }}
                >
                    Remover
                </Button>
            </Grid>
        );
    };



    const handleGoToHome = () => {
        if (hasDataFilled()) {
            setShowConfirmExit(true);
        } else {
            homeContext.setPageLocation(PageLocation.INFLUENCER_HOME);
        }
    };

    const inputTitleAndSubtitle = () => {
        return (
            <Grid
                container
                spacing={1}
                className={classes.titleContainer}
            >

                <Grid
                    item
                    xs={12}
                >
                    <Typography variant="h4">
                        Solicitação de Análise de Influenciadores
                    </Typography>
                </Grid>
                {/* <Grid
                    item
                    xs={12}
                >
                    <Typography variant="body1">
                        Para incluir um novo perfil, insira os dados solicitados abaixo
                    </Typography>
                </Grid> */}
            </Grid>
        );
    };

    const inputDataRecebimento = () => {
        const dataAtualFormatada = format(new Date(), 'dd/MM/yyyy');
        return (
            <Grid item xs={4}>
                <TextField
                    id="news-date"
                    label="Data de Recebimento"
                    value={dataAtualFormatada}
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                    InputProps={{
                        readOnly: true,
                    }}
                    fullWidth
                />
            </Grid>
        );
    };


    const inputNome = (index: number) => {
        return (
            <>
                <Grid item xs={8}>
                    <TextField
                        id={`nome-${index}`}
                        value={influencers[index]?.nome || ''}
                        onChange={handleChange(index, 'nome')}
                        label="Nome"
                        variant="outlined"
                        InputLabelProps={{ shrink: true }}
                        className={classes.itens} required error={!!erros[index]?.nome}
                    />
                    {erros[index]?.nome && (
                        <FormHelperText>Este campo é obrigatório.</FormHelperText>
                    )}
                </Grid>
            </>
        );
    };


    const inputUrlPerfil = (index: number) => {
        return (
            <>
                <Grid item xs={4}>
                    <TextField
                        id={`url_perfil-${index}`}
                        value={influencers[index]?.url_perfil || ''}
                        onChange={handleChange(index, 'url_perfil')}
                        label="URL da rede social principal*"
                        variant="outlined"
                        InputLabelProps={{ shrink: true }}
                        className={classes.itens} error={!!erros[index]?.url_perfil}
                    />
                    {erros[index]?.url_perfil && (
                        <FormHelperText error>{erros[index]?.url_perfil}</FormHelperText>
                    )}
                </Grid>
            </>
        );
    };
    const inputSolicitante = () => {
        return (
            <>
                <Grid item xs={4}>
                    <TextField
                        id="solicitante"
                        value={influencers[0]?.id_solicitante || ''}
                        label="Solicitante"
                        variant="outlined"
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                            readOnly: true,
                        }}
                        className={classes.itens} required error={!!erros[0]?.id_solicitante} />
                    {erros[0]?.id_solicitante && (
                        <FormHelperText error>Solicitante não encontrado.</FormHelperText>
                    )}
                </Grid>
            </>
        );
    };

    // const inputResponsavelReputacao = () => {
    //     return (
    //         <>
    //             <Grid item xs={4}>
    //                 <TextField
    //                     id="responsavelReputacao"
    //                     value={news.responsavelReputacao ?? ''}
    //                     // onChange={handleChangeSelect('responsavelReputacao')}
    //                     label="Responsável Reputação*"
    //                     variant="outlined"
    //                     InputLabelProps={{ shrink: true }}
    //                     InputProps={{
    //                         readOnly: true,
    //                     }}
    //                     className={classes.itens} required error={!!erros.responsavelReputacao} />
    //                 {erros.responsavelReputacao && (
    //                     <FormHelperText>Usuario não vinculado a um Responsavel de Reputação.</FormHelperText>
    //                 )}
    //             </Grid>
    //         </>
    //     );
    // };
    const inputEmail = () => {
        return (
            <>
                <Grid item xs={4}>
                    <TextField
                        id="email"
                        value={influencers[0]?.email || ''}
                        label="E-mail"
                        InputProps={{
                            readOnly: true,
                        }}
                        variant="outlined"
                        InputLabelProps={{ shrink: true }}
                        className={classes.itens} />
                </Grid>
            </>
        );
    };
    const inputIniciativa = () => {
        return (
            <>
                <Grid item xs={12}>
                    <TextField
                        id="iniciativa"
                        value={influencers[0]?.iniciativa || ''}
                        onChange={(event) => {
                            const newInfluencers = [...influencers];
                            newInfluencers.forEach(influencer => {
                                influencer.iniciativa = event.target.value;
                            });
                            setInfluencers(newInfluencers);
                        }}
                        label="Iniciativa*"
                        variant="outlined"
                        InputLabelProps={{ shrink: true }}
                        className={classes.itens} error={!!erros[0]?.iniciativa}
                    />
                    {erros[0]?.iniciativa && (
                        <FormHelperText>Este campo é obrigatório.</FormHelperText>
                    )}
                </Grid>
            </>
        );
    };
    const inputObservacoes = (index: number) => {
        return (
            <>
                <Grid item xs={12}>
                    <TextField
                        id={`observacoes-${index}`}
                        value={influencers[index]?.observacoes || ''}
                        onChange={handleChange(index, 'observacoes')}
                        multiline
                        minRows={3}
                        maxRows={3}
                        label="Observações"
                        variant="outlined"
                        InputLabelProps={{ shrink: true }}
                        className={classes.itens} />
                </Grid>
            </>
        );
    };
    const inputObjetivoContratação = () => {
        return (
            <>
                <Grid item xs={12}>
                    <TextField
                        id="objetivoContratacao"
                        value={influencers[0]?.objetivoContratacao || ''}
                        onChange={(event) => {
                            const newInfluencers = [...influencers];
                            newInfluencers.forEach(influencer => {
                                influencer.objetivoContratacao = event.target.value;
                            });
                            setInfluencers(newInfluencers);
                        }}
                        label="Objetivo de contratação/parceria*"
                        variant="outlined"
                        InputLabelProps={{ shrink: true }}
                        className={classes.itens} error={!!erros[0]?.objetivoContratacao}
                    />
                    {erros[0]?.objetivoContratacao && (
                        <FormHelperText>Este campo é obrigatório.</FormHelperText>
                    )}
                </Grid>
            </>
        );
    };

    const selectMarca = () => {
        return (
            <Grid item xs={4}>
                <FormControl
                    variant="outlined"
                    style={{ width: '100%' }}
                    required
                    error={!!erros[0]?.marca}
                >
                    <Autocomplete
                        id="marca-autocomplete"
                        options={filters?.marcas ?? []}
                        getOptionLabel={(option) => option.descricao || ''}
                        value={filters?.marcas?.find(m => m.descricao === influencers[0]?.marca) || null}
                        onChange={(_, newValue) => {
                            const newInfluencers = [...influencers];
                            newInfluencers.forEach(influencer => {
                                influencer.marca = newValue ? newValue.descricao : '';
                            });
                            setInfluencers(newInfluencers);
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Marca"
                                variant="outlined"
                                error={!!erros[0]?.marca}
                                required
                            />
                        )}
                    />
                    {erros[0]?.marca && (
                        <FormHelperText>Este campo é obrigatório.</FormHelperText>
                    )}
                </FormControl>
            </Grid>
        );
    };

    const selectArea = () => {
        return (
            <Grid item xs={4}>
                <FormControl
                    variant="outlined"
                    style={{ width: '100%' }}
                    required
                    error={!!erros[0]?.area}
                >
                    <Autocomplete
                        id="area-autocomplete"
                        options={filters?.area ?? []}
                        getOptionLabel={(option) => option.descricao || ''}
                        value={filters?.area?.find(a => a.descricao === influencers[0]?.area) || null}
                        onChange={(_, newValue) => {
                            const newInfluencers = [...influencers];
                            newInfluencers.forEach(influencer => {
                                influencer.area = newValue ? newValue.descricao : '';
                            });
                            setInfluencers(newInfluencers);
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Área"
                                variant="outlined"
                                error={!!erros[0]?.area}
                                required
                            />
                        )}
                    />
                    {erros[0]?.area && (
                        <FormHelperText>Este campo é obrigatório.</FormHelperText>
                    )}
                </FormControl>
            </Grid>
        );
    };

    const selectVp = () => {
        return (
            <Grid item xs={4}>
                <FormControl
                    variant="outlined"
                    style={{ width: '100%' }}
                    required
                    error={!!erros[0]?.vp}
                >
                    <Autocomplete
                        id="vp-autocomplete"
                        options={filters?.vp ?? []}
                        getOptionLabel={(option) => option.descricao || ''}
                        value={filters?.vp?.find(v => v.descricao === influencers[0]?.vp) || null}
                        onChange={(_, newValue) => {
                            const newInfluencers = [...influencers];
                            newInfluencers.forEach(influencer => {
                                influencer.vp = newValue ? newValue.descricao : '';
                            });
                            setInfluencers(newInfluencers);
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="VP"
                                variant="outlined"
                                error={!!erros[0]?.vp}
                                required
                            />
                        )}
                    />
                    {erros[0]?.vp && (
                        <FormHelperText>Este campo é obrigatório.</FormHelperText>
                    )}
                </FormControl>
            </Grid>
        );
    };


    const selectFinalidade = () => {
        return (
            <Grid item xs={8}>
                <FormControl
                    variant="outlined"
                    style={{ width: '100%' }}
                    required
                    error={!!erros[0]?.finalidade}
                >
                    <Autocomplete
                        id="finalidade-autocomplete"
                        options={filters?.finalidades ?? []}
                        getOptionLabel={(option) => option.descricao || ''}
                        value={filters?.finalidades?.find(f => f.descricao === influencers[0]?.finalidade) || null}
                        onChange={(_, newValue) => {
                            const newInfluencers = [...influencers];
                            newInfluencers.forEach(influencer => {
                                influencer.finalidade = newValue ? newValue.descricao : '';
                            });
                            setInfluencers(newInfluencers);
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Finalidade"
                                variant="outlined"
                                error={!!erros[0]?.finalidade}
                                required
                            />
                        )}
                    />
                    {erros[0]?.finalidade && (
                        <FormHelperText>Este campo é obrigatório.</FormHelperText>
                    )}
                </FormControl>
            </Grid>
        );
    };

    const selectFormato = () => {
        return (
            <Grid item xs={4}>
                <FormControl
                    variant="outlined"
                    style={{ width: '100%' }}
                    required
                    error={!!erros[0]?.formato}
                >
                    <Autocomplete
                        id="formato-autocomplete"
                        options={filters?.formato ?? []}
                        getOptionLabel={(option) => option.descricao || ''}
                        value={filters?.formato?.find(f => f.descricao === influencers[0]?.formato) || null}
                        onChange={(_, newValue) => {
                            const newInfluencers = [...influencers];
                            newInfluencers.forEach(influencer => {
                                influencer.formato = newValue ? newValue.descricao : '';
                            });
                            setInfluencers(newInfluencers);
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Formato"
                                variant="outlined"
                                error={!!erros[0]?.formato}
                                required
                            />
                        )}
                    />
                    {erros[0]?.formato && (
                        <FormHelperText>Este campo é obrigatório.</FormHelperText>
                    )}
                </FormControl>
            </Grid>
        );
    };

    const selectAbrangencia = () => {
        return (
            <Grid item xs={4}>
                <FormControl
                    variant="outlined"
                    style={{ width: '100%' }}
                    required
                    error={!!erros[0]?.abrangencia}
                >
                    <Autocomplete
                        id="abrangencia-autocomplete"
                        options={filters?.abrangencia ?? []}
                        getOptionLabel={(option) => option.descricao || ''}
                        value={filters?.abrangencia?.find(a => a.descricao === influencers[0]?.abrangencia) || null}
                        onChange={(_, newValue) => {
                            const newInfluencers = [...influencers];
                            newInfluencers.forEach(influencer => {
                                influencer.abrangencia = newValue ? newValue.descricao : '';
                            });
                            setInfluencers(newInfluencers);
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Abrangência"
                                variant="outlined"
                                error={!!erros[0]?.abrangencia}
                                required
                            />
                        )}
                    />
                    {erros[0]?.abrangencia && (
                        <FormHelperText>Este campo é obrigatório.</FormHelperText>
                    )}
                </FormControl>
            </Grid>
        );
    };

    const selectCanais = () => {
        return (
            <Grid item xs={8}>
                <FormControl
                    variant="outlined"
                    style={{ width: '100%' }}
                    required
                    error={!!erros[0]?.canaisICE}
                >
                    <Autocomplete
                        multiple
                        id="canais-autocomplete"
                        options={filters?.canais ?? []}
                        getOptionLabel={(option) => option.descricao || ''}
                        value={filters?.canais?.filter((c) => Array.isArray(influencers[0]?.canaisICE) && influencers[0].canaisICE.includes(c.descricao)) || []}
                        onChange={(_, newValue) => {
                            const newInfluencers = [...influencers];
                            const canaisICE = newValue.map((c) => c.descricao).filter(Boolean);
                            newInfluencers.forEach(influencer => {
                                influencer.canaisICE = canaisICE;
                            });
                            setInfluencers(newInfluencers);
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Canais de divulgação"
                                variant="outlined"
                                error={!!erros[0]?.canaisICE}
                                required
                            />
                        )}
                        disableCloseOnSelect
                    />
                    {erros[0]?.canaisICE && (
                        <FormHelperText>Este campo é obrigatório.</FormHelperText>
                    )}
                </FormControl>
            </Grid>
        );
    };







    const AccordionProfileData = () => {
        return (
            <Grid>
                {/* Dados do Influenciador Principal */}
                <Grid container spacing={4} style={{ marginBottom: '2rem' }}>
                    {inputSolicitante()}
                    {inputEmail()}
                    {inputDataRecebimento()}
                    {selectArea()}
                    {selectVp()}
                    {selectMarca()}
                    {inputIniciativa()}
                    {inputObjetivoContratação()}
                    {selectFinalidade()}
                    {selectFormato()}
                    {selectCanais()}
                    {selectAbrangencia()}
                </Grid>
                <Grid
                    container spacing={4} style={{
                        marginBottom: '2rem',
                        padding: '1rem',
                        border: '1px solid #e0e0e0',
                        borderRadius: '8px',
                        backgroundColor: '#FFFFF'
                    }}>
                    {inputNome(0)}
                    {inputUrlPerfil(0)}
                    {inputObservacoes(0)}
                    <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                        {saveAddInputs()}
                    </Grid>
                </Grid>

                {/* Campos específicos dos influenciadores adicionais */}
                {influencers.slice(1).map((_, index) => {
                    const actualIndex = index + 1;
                    return (
                        <Grid key={actualIndex} container spacing={4} style={{
                            marginBottom: '2rem',
                            padding: '1rem',
                            border: '1px solid #e0e0e0',
                            borderRadius: '8px',
                            backgroundColor: '#FFFFF'
                        }}>
                            {inputNome(actualIndex)}
                            {inputUrlPerfil(actualIndex)}
                            {inputObservacoes(actualIndex)}
                            <Grid container
                                justifyContent="flex-end"
                                alignItems="center"
                                spacing={3}>
                                {saveRemoveInputs(actualIndex)}
                                {saveAddInputs()}
                            </Grid>
                        </Grid>
                    );
                })}
            </Grid>
        );
    };

    return (
        <>
            {!loading &&
                <Grid
                    container
                    justifyContent="center"
                    alignItems="center"
                >
                    <Grid container className={classes.toolbar} justifyContent="center"
                        alignItems="center">
                        <Grid
                            item
                            className={classes.baritems}
                            direction="column"
                        >
                            <Button
                                variant="text"
                                onClick={handleGoToHome}
                                style={{
                                    textTransform: 'initial',
                                    color: theme.palette.primary.main,
                                    padding: '8px 0px',
                                    fontSize: '14px'
                                }}
                            >
                                ← Voltar para a página inicial
                            </Button>
                        </Grid>
                    </Grid>
                    <Grid
                        item
                        className={classes.root}
                        direction="column"
                    >
                        <Grid
                            container
                            direction="row"
                            className={classes.root}
                            spacing={4}
                            alignItems="center"
                        >
                            {inputTitleAndSubtitle()}
                        </Grid>
                        <Grid container alignItems="center" spacing={3}>
                            <Grid item xs={12}>{AccordionProfileData()}</Grid>
                            <Grid item xs={12}>{saveInputs()}</Grid>
                            <Grid item xs={12}>
                                <Typography
                                    variant="body2"
                                    color="textSecondary"
                                    style={{
                                        marginTop: theme.spacing(2),
                                        padding: theme.spacing(2),
                                        backgroundColor: '#f5f5f5',
                                        borderRadius: '8px',
                                        border: '1px solid #e0e0e0'
                                    }}
                                >
                                    <strong>Sobre os botões:</strong><br />
                                    • <strong>+ Adicionar Perfil:</strong> Adiciona um novo formulário para cadastrar outro influenciador<br />
                                    • <strong>Remover:</strong> Remove o formulário do influenciador correspondente<br />
                                    • <strong>Enviar:</strong> Envia todos os influenciadores cadastrados para análise
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            }
            {loading && <Grid container
                direction="row"
                justify="center"
                alignItems="center"
                className={classes.loading}>
                <CircularProgress color="primary" size="124px" />
                <Typography
                    variant="h5"
                    className={classes.titleContainer}
                >
                    Carregando...
                </Typography>
            </Grid>}
            <BasicConfirmDialog
                title="Sair sem salvar?"
                description="Ao sair sem salvar, você perderá todos os dados de solicitação já preenchidos."
                handleFirstButton={() => homeContext.setPageLocation(PageLocation.INFLUENCER_HOME)}
                handleSecondButton={() => setShowConfirmExit(false)}
                textFirstButton="SAIR"
                textSecondButton="Permanecer na página"
                cssProperties={{
                    maxWidth: '550px'
                }}
                open={showConfirmExit} />
        </>
    );
}